export default "__VITE_ASSET__gNIkPWnT__"